export interface Review {
  id: string;
  itemId: string;
  author: string;
  avatarSeed: string;
  rating: number;
  content: string;
}

export const reviews: Review[] = [
  {
    id: 'r1',
    itemId: 'm1',
    author: '银幕观察员',
    avatarSeed: 'A',
    rating: 9,
    content:
      '很少见国产科幻把“孤独”拍得这么克制。中段那段舱内长镜头几乎没有台词，却靠光影和呼吸声把紧张感拉满。最后二十分钟的抉择戏值得二刷。',
  },
  {
    id: 'r2',
    itemId: 'm1',
    author: '深夜放映室',
    avatarSeed: 'B',
    rating: 8,
    content: '美术和音效是最大惊喜，世界观铺得很扎实。如果结尾能再收敛一点就更好了，但仍然值得进影院。',
  },
  {
    id: 'r3',
    itemId: 'm2',
    author: '长安旧客',
    avatarSeed: 'C',
    rating: 9,
    content: '夜戏的灯光处理太舒服了，两万盏灯笼不是白搭的。探案线虽然不复杂，但节奏稳，人物立得住。',
  },
  {
    id: 'r4',
    itemId: 't1',
    author: '追剧不熬夜',
    avatarSeed: 'D',
    rating: 9,
    content: '群像写得很好，三个人各有各的执念，谁也不工具人。前六集铺陈稍慢，但第十集之后基本停不下来。',
  },
  {
    id: 'r5',
    itemId: 't4',
    author: '星海拾荒者',
    avatarSeed: 'E',
    rating: 8,
    content: '安静得让人心里发慌，这正是它的厉害之处。没有打斗，没有大场面，就是一个人对着通讯器说话，但你会在某一秒突然被击中。',
  },
  {
    id: 'r6',
    itemId: 'm5',
    author: '山海拾遗',
    avatarSeed: 'F',
    rating: 8,
    content: '东方奇幻终于不靠堆砌特效了。云海那段长镜头很惊艳，毕方出场的处理也有分寸。适合带孩子一起看。',
  },
  {
    id: 'r7',
    itemId: 'm7',
    author: '城市夜归人',
    avatarSeed: 'G',
    rating: 9,
    content: '看完很久没缓过来。它没有刻意煽情，只是把这座城市里那些没人看见的人轻轻摆到镜头前，就够了。',
  },
  {
    id: 'r8',
    itemId: 'm6',
    author: '信箱里的猫',
    avatarSeed: 'H',
    rating: 7,
    content: '设定有点取巧，但胜在真诚。最后一封信的处理很温柔，作为周末的治愈片刚刚好。',
  },
];

export const defaultReviews: Review[] = [
  {
    id: 'rd1',
    itemId: 'default',
    author: '快活影院编辑部',
    avatarSeed: 'K',
    rating: 8,
    content:
      '整体完成度不错，视觉风格统一，节奏也没有明显的拖沓。适合在周末的晚上安静看完，属于看完会想推荐给朋友的那类作品。',
  },
  {
    id: 'rd2',
    itemId: 'default',
    author: '观影笔记',
    avatarSeed: 'L',
    rating: 7,
    content: '题材不算新鲜，但细节处理得很用心。配角的表现比预期亮眼，几场对话戏值得反复回味。',
  },
  {
    id: 'rd3',
    itemId: 'default',
    author: '散场之后',
    avatarSeed: 'M',
    rating: 8,
    content: '前段铺垫略慢，进入后半程之后情绪一路走高。如果喜欢有留白的叙事，这部应该会很对你胃口。',
  },
];